import React from 'react'
import ICSButton from '../../ICS/Button/ICSButton'

const BackButton = () => (
  <ICSButton
    height='100%'
    id='backButton'
    className='wivi-btn'
    onClick={() => window.history.back()}
    type='success'
  >
    Back
  </ICSButton>
)

export default BackButton
